export const apiErrorParser = async <T extends object>(error: T): Promise<{ original: T; parsed?: Error }> => {
  if ("status" in error && "json" in error && typeof error.json === "function" && error.status === 400) {
    try {
      const parsedError = await error.json();

      if (
        parsedError?.errors &&
        parsedError?.errors instanceof Array &&
        (parsedError?.errors ?? [])[0]?.message &&
        typeof parsedError?.errors[0]?.message === "string"
      ) {
        return { original: error, parsed: new Error(parsedError?.errors[0]?.message) };
      }

      if (typeof parsedError?.detail === "string") {
        return { original: error, parsed: new Error(parsedError?.detail) };
      }

      return parsedError;
    } catch {
      return { original: error };
    }
  }

  return { original: error };
};
